/**
 * Bengali (বাংলা) translations
 */
import { TranslationStrings } from '../types';

export const bn: TranslationStrings = {  common: {
    loading: 'লোড হচ্ছে...',
    error: 'একটি ত্রুটি ঘটেছে',
    retry: 'আবার চেষ্টা করুন',
    cancel: 'বাতিল',
    confirm: 'নিশ্চিত করুন',
    back: 'পিছনে',
    next: 'পরবর্তী',
    submit: 'জমা দিন',
    done: 'সম্পন্ন',
    close: 'বন্ধ',
    yes: 'হ্যাঁ',
    no: 'না',
    required: 'প্রয়োজনীয়',
    optional: 'ঐচ্ছিক',
  },
  consent: {
    secureConsent: 'নিরাপদ সম্মতি',
    yourConsentRequired: 'আপনার সম্মতি প্রয়োজন',
    consentingAs: 'হিসাবে সম্মতি দিচ্ছেন',
    requestingOrg: 'অনুরোধকারী সংস্থা',
    dataBeingCollected: 'সংগ্রহ করা হচ্ছে এমন ডেটা',
    purposeOfProcessing: 'প্রক্রিয়াকরণের উদ্দেশ্য',
    whatYouWillDo: 'আপনি যা করবেন',
    reviewDocuments: 'নথি পর্যালোচনা করুন',
    provideConsent: 'সম্মতি দিন',
    documentsToRead: 'পড়ার জন্য নথি',
    estimatedTime: 'আনুমানিক সময়',
    minutes: 'মিনিট',
    startReview: 'পর্যালোচনা শুরু করুন',
    yourRights: 'DPDP আইন 2023 এর অধীনে আপনার অধিকার',
    rightToAccess: 'আপনার ডেটা অ্যাক্সেস করার অধিকার',
    rightToCorrect: 'আপনার ডেটা সংশোধন করার অধিকার',
    rightToWithdraw: 'সম্মতি প্রত্যাহার করার অধিকার',
    rightToGrievance: 'অভিযোগ দায়ের করার অধিকার',
    stepOf: 'ধাপ {current} / {total}',
    pleaseReadCarefully: 'সম্মতি দেওয়ার আগে প্রতিটি নথি মনোযোগ সহকারে পড়ুন।',
    documentsReviewed: 'পর্যালোচিত নথি',
    remaining: 'অবশিষ্ট',
    allDocumentsReviewed: 'সমস্ত নথি পর্যালোচনা করা হয়েছে!',
    clickToRead: 'পড়তে প্রতিটি নথিতে ক্লিক করুন',
    proceedToConsent: 'আপনি সম্মতি দিতে এগিয়ে যেতে পারেন',
    markAsRead: 'পঠিত হিসাবে চিহ্নিত করুন',
    continueReading: 'পড়া চালিয়ে যান',
    confirmConsent: 'আপনার সম্মতি নিশ্চিত করুন',
    selectMethod: 'যাচাইকরণ পদ্ধতি নির্বাচন করুন',
    iAgreeToTerms: 'আমি সমস্ত শর্তাবলী, নীতি এবং সম্মতি চুক্তিতে সম্মত',
    readAllDocuments: 'আমি বুঝি যে আমার সম্মতি স্বেচ্ছায় এবং যেকোনো সময় প্রত্যাহার করা যেতে পারে',
    submitConsent: 'সম্মতি জমা দিন',
    submitting: 'জমা দেওয়া হচ্ছে...',
    digitalSignature: 'ডিজিটাল স্বাক্ষর',
    smsVerification: 'SMS যাচাইকরণ',
    emailVerification: 'ইমেল যাচাইকরণ',
    videoRecording: 'ভিডিও রেকর্ডিং',
    audioRecording: 'অডিও রেকর্ডিং',
    checkboxConfirmation: 'চেকবক্স নিশ্চিতকরণ',
    drawSignature: 'আপনার স্বাক্ষর আঁকুন',
    verifyViaSms: 'SMS কোড দিয়ে যাচাই করুন',
    verifyViaEmail: 'ইমেল কোড দিয়ে যাচাই করুন',
    recordVideoConsent: 'ভিডিও সম্মতি রেকর্ড করুন',
    recordAudioConsent: 'অডিও সম্মতি রেকর্ড করুন',
    confirmByChecking: 'চেক করে নিশ্চিত করুন',
    enterOtp: 'OTP প্রবেশ করুন',
    otpSentTo: 'OTP পাঠানো হয়েছে',
    resendOtp: 'OTP পুনরায় পাঠান',
    verifyOtp: 'OTP যাচাই করুন',
    otpVerified: 'OTP যাচাই হয়েছে',
    invalidOtp: 'অবৈধ OTP',
    startRecording: 'রেকর্ডিং শুরু করুন',
    stopRecording: 'রেকর্ডিং বন্ধ করুন',
    retake: 'আবার নিন',
    recordingComplete: 'রেকর্ডিং সম্পূর্ণ',
    consentSubmitted: 'সম্মতি সফলভাবে জমা দেওয়া হয়েছে',
    thankYou: 'সম্মতি দেওয়ার জন্য ধন্যবাদ',
    confirmationSent: 'আপনার ইমেলে নিশ্চিতকরণ পাঠানো হয়েছে',
    referenceNumber: 'রেফারেন্স নম্বর',
    errorSubmitting: 'সম্মতি জমা দিতে ব্যর্থ। আবার চেষ্টা করুন।',
    pleaseReadDocs: 'প্রথমে সমস্ত নথি পড়ুন',
    pleaseProvideEvidence: 'সম্মতির প্রমাণ দিন',
  },
  documents: {
    privacyPolicy: 'গোপনীয়তা নীতি',
    termsOfService: 'সেবার শর্তাবলী',
    consentAgreement: 'সম্মতি',
    dataSharingAgreement: 'ডেটা শেয়ারিং চুক্তি',
    cookiePolicy: 'কুকি নীতি',
    retentionPolicy: 'ডেটা ধারণ নীতি',
    gdprNotice: 'GDPR নোটিশ',
    hipaaAuthorization: 'HIPAA অনুমোদন',
    ccpaDisclosure: 'CCPA প্রকাশ',
    aadhaarAuthorization: 'আধার অনুমোদন',
    customDocument: 'কাস্টম নথি',
  },
  dataCategories: {
    personalInfo: 'ব্যক্তিগত তথ্য',
    contactDetails: 'যোগাযোগের বিবরণ',
    financialInfo: 'আর্থিক তথ্য',
    healthData: 'স্বাস্থ্য ও চিকিৎসা ডেটা',
    biometricData: 'বায়োমেট্রিক ডেটা',
    locationData: 'অবস্থান ডেটা',
    behavioralData: 'আচরণগত ডেটা',
    communicationData: 'যোগাযোগ ডেটা',
    employmentInfo: 'কর্মসংস্থান তথ্য',
    educationInfo: 'শিক্ষাগত তথ্য',
  },
  a11y: {
    mainContent: 'প্রধান বিষয়বস্তু',
    navigation: 'নেভিগেশন',
    closeModal: 'মোডাল বন্ধ করুন',
    expandSection: 'বিভাগ প্রসারিত করুন',
    collapseSection: 'বিভাগ সংকুচিত করুন',
    documentRead: 'নথি পঠিত হিসাবে চিহ্নিত',
    documentUnread: 'নথি এখনও পড়া হয়নি',
    progressIndicator: 'অগ্রগতি: {current} / {total} নথি পড়া হয়েছে',
    signaturePad: 'স্বাক্ষর এলাকা',
    clearSignature: 'স্বাক্ষর মুছুন',
    videoPlayer: 'ভিডিও রেকর্ডিং প্লেয়ার',
    audioPlayer: 'অডিও রেকর্ডিং প্লেয়ার',
    requiredField: 'এই ক্ষেত্রটি প্রয়োজনীয়',
    errorMessage: 'ত্রুটি',
    successMessage: 'সাফল্য',
    loadingContent: 'বিষয়বস্তু লোড হচ্ছে, অপেক্ষা করুন',
    newWindow: 'নতুন উইন্ডোতে খুলবে',
  },
  portal: {
    // General
    myConsents: 'আমার সম্মতিসমূহ',
    viewManageConsents: 'আপনার সম্মতি রেকর্ড দেখুন এবং পরিচালনা করুন',
    logout: 'লগআউট',
    welcomeBack: 'ফিরে আসার জন্য স্বাগতম',
    
    // Tenant selector
    organizationNameOrCode: 'প্রতিষ্ঠানের নাম বা কোড',
    orgPlaceholder: 'যেমন, globalhealth বা acme-corp',
    orgHint: 'আপনার প্রতিষ্ঠান প্রদত্ত নাম বা কোড লিখুন',
    findMyOrganization: 'আমার প্রতিষ্ঠান খুঁজুন',
    orgNotFound: 'প্রতিষ্ঠান পাওয়া যায়নি। নাম পরীক্ষা করে আবার চেষ্টা করুন।',
    enterOrgName: 'দয়া করে আপনার প্রতিষ্ঠানের নাম বা কোড লিখুন',
    or: 'অথবা',
    haveDirectLink: 'আপনার প্রতিষ্ঠান থেকে সরাসরি লিঙ্ক আছে?',
    useDirectLink: 'তারা প্রদান করা লিঙ্ক ব্যবহার করুন',
    privacyProtected: 'আপনার গোপনীয়তা আইন দ্বারা সুরক্ষিত',
    
    // Login flow
    phoneOrEmail: 'ফোন নম্বর বা ইমেইল',
    enterPhoneOrEmailPlaceholder: 'আপনার নিবন্ধিত ফোন বা ইমেইল লিখুন',
    otpWillBeSent: 'আমরা আপনাকে একটি ওয়ান-টাইম পাসওয়ার্ড (OTP) পাঠাব',
    sendOtp: 'OTP পাঠান',
    enterPhoneOrEmail: 'দয়া করে আপনার ফোন নম্বর বা ইমেইল লিখুন',
    otpSentTo: 'OTP পাঠানো হয়েছে',
    expiresIn: 'মেয়াদ শেষ হবে',
    enterOtp: 'OTP লিখুন',
    enterValidOtp: 'দয়া করে বৈধ OTP লিখুন',
    verifyOtp: 'OTP যাচাই করুন',
    resendOtp: 'OTP পুনরায় পাঠান',
    otpVerified: 'OTP যাচাই হয়েছে',
    oneMoreStep: 'আপনার পরিচয় যাচাই করতে আরেকটি ধাপ',
    enterSecurityAnswer: 'দয়া করে আপনার উত্তর লিখুন',
    enterAnswer: 'উত্তর লিখুন',
    dobFormat: 'ফরম্যাট: DDMMYYYY (যেমন, 15051990 মে 15, 1990)',
    login: 'লগইন',
    startOver: 'আবার শুরু করুন',
    needHelp: 'সাহায্য দরকার?',
    privacyNotice: 'আপনার ডেটা প্রযোজ্য গোপনীয়তা আইনের অধীনে সুরক্ষিত',
    checkUrlOrContact: 'দয়া করে URL পরীক্ষা করুন বা আপনার প্রতিষ্ঠানের সাথে যোগাযোগ করুন।',
    
    // Consent history
    filterAll: 'সব',
    statusActive: 'সক্রিয়',
    statusWithdrawn: 'প্রত্যাহার করা হয়েছে',
    statusExpired: 'মেয়াদ শেষ',
    noConsents: 'কোন সম্মতি রেকর্ড পাওয়া যায়নি',
    noConsentsWithFilter: 'এই স্থিতিতে কোন সম্মতি নেই',
    consentedOn: 'সম্মতি দেওয়া হয়েছে',
    expiresOn: 'মেয়াদ শেষ হবে',
    withdrawnOn: 'প্রত্যাহার করা হয়েছে',
    withdrawConsent: 'সম্মতি প্রত্যাহার করুন',
    withdrawalHistory: 'প্রত্যাহার ইতিহাস',
    help: 'সাহায্য',
    
    // Withdrawal
    cannotWithdraw: 'এই সম্মতি প্রত্যাহার করা যাবে না',
    pleaseConfirmWithdrawal: 'দয়া করে নিশ্চিত করুন যে আপনি পরিণাম বুঝতে পেরেছেন',
    importantNotice: 'গুরুত্বপূর্ণ নোটিশ',
    withdrawalNotice1: 'প্রতিষ্ঠান উল্লেখিত উদ্দেশ্যে আপনার ডেটা প্রক্রিয়াকরণ বন্ধ করবে।',
    withdrawalNotice2: 'আইনি সম্মতির জন্য কিছু ডেটা রাখা হতে পারে।',
    withdrawalNotice3: 'কিছু সেবা ব্যবহার করতে আপনাকে আবার সম্মতি দিতে হতে পারে।',
    withdrawalNotice4: 'প্রযোজ্য আইন অনুযায়ী প্রক্রিয়াকরণ সময় 7-30 দিন লাগতে পারে।',
    withdrawalReason: 'প্রত্যাহারের কারণ',
    withdrawalReasonPlaceholder: 'আপনি কেন প্রত্যাহার করতে চান তা বলুন (ঐচ্ছিক)',
    withdrawalConfirmation: 'আমি বুঝি যে আমার সম্মতি প্রত্যাহার করলে কিছু সেবা ব্যবহার করার ক্ষমতা প্রভাবিত হতে পারে, এবং আমি এই অনুরোধ নিয়ে এগিয়ে যেতে চাই।',
    submitWithdrawalRequest: 'প্রত্যাহার অনুরোধ জমা দিন',
    withdrawalSubmitted: 'প্রত্যাহার অনুরোধ জমা হয়েছে',
    withdrawalSubmittedDesc: 'আপনার প্রত্যাহার অনুরোধ জমা হয়েছে। প্রতিষ্ঠান প্রক্রিয়া করার পরে আপনাকে জানানো হবে।',
    processingTime: 'প্রক্রিয়াকরণ সময়',
    days: 'দিন',
    backToHistory: 'সম্মতি ইতিহাসে ফিরে যান',
    
    // Withdrawal history
    statusPending: 'মুলতুবি',
    statusApproved: 'অনুমোদিত',
    statusRejected: 'প্রত্যাখ্যাত',
    noWithdrawals: 'কোন প্রত্যাহার অনুরোধ নেই',
    viewConsents: 'আপনার সম্মতি দেখুন',
    requestedOn: 'অনুরোধ করা হয়েছে',
    processedOn: 'প্রক্রিয়া করা হয়েছে',
    processingMessage: 'আপনার অনুরোধ প্রক্রিয়া হচ্ছে। সম্পূর্ণ হলে আপনাকে জানানো হবে।',
    processingTimeInfo: 'প্রক্রিয়াকরণ সময় তথ্য',
    
    // Help section
    yourRights: 'আপনার গোপনীয়তা অধিকার',
    helpTitle: 'আপনার গোপনীয়তা অধিকার বুঝুন',
    helpSubtitle: 'গোপনীয়তা আইনের অধীনে আপনার অধিকার এবং সম্মতি কীভাবে পরিচালনা করবেন তা জানুন।',
    quickActions: 'দ্রুত কার্যক্রম',
    viewMyConsents: 'আমার সম্মতি দেখুন',
    viewWithdrawalRequests: 'প্রত্যাহার অনুরোধ দেখুন',
    loginToViewConsents: 'আপনার সম্মতি দেখতে লগইন করুন',
    applicableLaws: 'প্রযোজ্য গোপনীয়তা আইন',
    
    // Rights FAQ
    rightAccessQ: 'অ্যাক্সেস অধিকার কী?',
    rightAccessA: 'আপনার সম্পর্কে কী ব্যক্তিগত ডেটা সংগ্রহ করা হচ্ছে, এটি কীভাবে ব্যবহার করা হচ্ছে, কার সাথে শেয়ার করা হচ্ছে তা জানার অধিকার আপনার আছে।',
    rightCorrectQ: 'সংশোধন অধিকার কী?',
    rightCorrectA: 'আপনার ব্যক্তিগত ডেটা ভুল বা অসম্পূর্ণ হলে, আপনি এটি সংশোধন বা আপডেট করার অনুরোধ করতে পারেন।',
    rightWithdrawQ: 'সম্মতি প্রত্যাহার অধিকার কী?',
    rightWithdrawA: 'আপনি যেকোনো সময় আপনার সম্মতি প্রত্যাহার করতে পারেন। প্রত্যাহারের পরে, আপনি যে উদ্দেশ্যে সম্মতি দিয়েছিলেন সেই উদ্দেশ্যে আপনার ডেটা প্রক্রিয়াকরণ বন্ধ করতে হবে।',
    rightEraseQ: 'মুছে ফেলার অধিকার কী?',
    rightEraseA: '"ভুলে যাওয়ার অধিকার" নামেও পরিচিত, আপনি আপনার ব্যক্তিগত ডেটা মুছে ফেলার অনুরোধ করতে পারেন। তবে, কিছু তথ্য রাখার জন্য আইনি কারণ থাকতে পারে।',
    
    // Withdrawal FAQ
    withdrawalFaq: 'প্রত্যাহার প্রক্রিয়া',
    withdrawHowQ: 'আমার সম্মতি কীভাবে প্রত্যাহার করব?',
    withdrawHowA: 'আপনার অ্যাকাউন্টে লগইন করুন, সম্মতি ইতিহাসে যান, সক্রিয় সম্মতিতে "সম্মতি প্রত্যাহার করুন" ক্লিক করুন।',
    withdrawTimeQ: 'প্রত্যাহার করতে কতক্ষণ লাগে?',
    withdrawTimeA: 'প্রযোজ্য আইন অনুযায়ী প্রক্রিয়াকরণ সময়: DPDP আইন (ভারত) - 7 দিন, GDPR (EU) - 30 দিন, CCPA (ক্যালিফোর্নিয়া) - 45 দিন।',
    withdrawEffectQ: 'সম্মতি প্রত্যাহারের পরে কী হয়?',
    withdrawEffectA: 'প্রতিষ্ঠান উল্লেখিত উদ্দেশ্যে আপনার ডেটা ব্যবহার বন্ধ করবে। আইনি সম্মতির জন্য কিছু ডেটা রাখা হতে পারে।',
    
    // Security FAQ
    securityFaq: 'অ্যাকাউন্ট নিরাপত্তা',
    loginSecureQ: 'আমার লগইন কীভাবে সুরক্ষিত?',
    loginSecureA: 'আমরা 3-ধাপ যাচাইকরণ প্রক্রিয়া ব্যবহার করি: নিবন্ধিত ফোন/ইমেইলে OTP, তারপর নিরাপত্তা প্রশ্ন।',
    dataProtectQ: 'আমার ডেটা কীভাবে সুরক্ষিত?',
    dataProtectA: 'সমস্ত ডেটা ট্রানজিট এবং রেস্টে এনক্রিপ্ট করা হয়। DPDP আইন, GDPR এবং অন্যান্য গোপনীয়তা বিধি মেনে চলি।',
    
    // Contact FAQ
    contactFaq: 'যোগাযোগ ও সাপোর্ট',
    grievanceQ: 'অভিযোগ কীভাবে দাখিল করব?',
    grievanceA: 'প্রতিষ্ঠানের ডেটা প্রোটেকশন অফিসার (DPO) বা অভিযোগ অফিসারের সাথে যোগাযোগ করতে পারেন।',
    regulatorQ: 'নিয়ন্ত্রক কর্তৃপক্ষ কে?',
    regulatorA: 'ভারতে, ডেটা প্রোটেকশন বোর্ড গোপনীয়তা অভিযোগ পরিচালনা করে। EU তে, আপনার জাতীয় ডেটা প্রোটেকশন অথরিটির সাথে যোগাযোগ করতে পারেন।',
  },
}
;
